import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NavbarService } from '../navbar.service';
import { StudentapiService } from '../studentapi.service';
import { ReCaptcha2Component } from 'ngx-captcha';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    // captcha
    formlogin !: FormGroup;
@ViewChild('captchaElem')
captchaElem!: ReCaptcha2Component ;
@ViewChild('langInput')
langInput!: ElementRef;
public captchaIsLoaded = false;
public captchaSuccess = false;
public captchaIsExpired = false;
public captchaResponse?: string;

public theme: 'light' | 'dark' = 'light';
public size: 'compact' | 'normal' = 'normal';
public lang = 'en';
public type!: 'image' | 'audio';
// end captcha
  loginuser: any;
  user_id: any;
  username: any;
  password: any;
  test: any;
 

  constructor(public formbuilder:FormBuilder, public router:Router, private api:StudentapiService,public nav:NavbarService) {
  

   }

  ngOnInit(): void {

    this.nav.hide();
    this.nav.dhide();
    this.nav.adhide();

    this.formlogin = this.formbuilder.group({
      username :['', Validators.required],
      password:['', Validators.required],
      recaptcha: ['', Validators.required]
   
    });
    
 
  }

   // used for google captcha site
   siteKey: string="6LdVAlUaAAAAAOKqf4EZ5ZfTBlrUsWWRAa_jMrZn";
   handleSuccess(data:any) {
     // console.log(data);
   }

  submitlogin(){
   
      let user:{username:any,password:any}={
        
        username : this.formlogin.controls.username.value,
        password : this.formlogin.controls.password.value
      }
      console.log(user);
      if(this.formlogin.controls.recaptcha.value == "")
      {
          alert('Please Select Captcha');
      }
      else
      {
        let seq = this.api.post('/StudentApi/userlogin',user);
        seq.subscribe((res:any) =>{
          // console.log(res);
          // const abc = ['usename', 'password', 'date'];
          this.loginuser = res['Data'];
          // const user = this.loginuser[0];
          this.user_id = this.loginuser[0].user_id;
          this.username = this.loginuser[0].username;
          this.password = this.loginuser[0].password;
          // console.log(this.user_id);
          // const result = [];
          // abc.forEach(item => {
          //   if(user[item]) {
          //     result.push({
          //       key: 'abcd',
          //       value: user[item]
          //     })
          //   }
          // });
          
          // console.log(result);
          // console.log(this.username);
          
          localStorage.setItem('username',this.username);
          localStorage.setItem('password',this.password);
          localStorage.setItem('user_id',this.user_id);
          this.router.navigate(['/home'])
          .then(() => {
            window.location.reload();
          });
        },err=>{
          alert("Invalid Username/Password!");
              // this.formlogin.get('username').setValue("");
              // this.formlogin.get('password').setValue("");
        })
      }
    
  }

}
